import Vue from "vue";
import {
  AddNotificationCountToIndexedDB,
  AddReadNotificationToIndexedDB,
  AddUnreadNotificationToIndexedDB,
  DeleteNotificationIndexedDB,
  GetNotificationCountFromIndexedDB,
  GetReadNotificationFromIndexedDB,
  GetUnreadNotificationFromIndexedDB,
  UpdateNotificationCountToIndexedDB,
  UpdateReadNotificationToIndexedDB,
  UpdateUnreadNotificationToIndexedDB,
} from "../IndexedDB/notificationIndexedDB";
import { DeleteTabFromIndexedDB } from "../IndexedDB/tabIndexedDB";
import {
  BroadcastDisconnectNotificationAllTab,
  BroadcastIsUpdateNotificationCount,
  BroadcastIsUpdateNotificationList,
  BroadcastMasterDeleteNotificationById,
  BroadcastMasterSetNotificationIsSeenAll,
  BroadcastReCreateTab,
} from "../broadcastChannel/userChannel";
import store from "../controller/baseController";
import enums from "../enums/enums";
import userInfo from "../function/userInfo";
import i18n from "../locales/i18n";
import {
  ClearTabFromLocalStorage,
  ClearTabFromSessionStorage,
  GetAllTabs,
  GetTabIdFromSessionStorage,
  InsertTabIdToTabDB,
  IsMasterTab,
  IsMasterTabAvailable,
  SetMasterTab,
  UpdateTabMerchantId,
} from "./tabHelper";
const appVue = new Vue();
let timerCheckAccessToken = null;

export const SetTimerCheckAccessToken = () => {
  if (IsMasterTab()) {
    timerCheckAccessToken = setInterval(async () => {
      const isCanUseAccessToken = await store.dispatch("DoIntrospectAccessToken");
      if (isCanUseAccessToken) {
        await store.dispatch("DoUpdateAccessToken");
      } else {
        const isCanNewUseAccessToken = await store.dispatch("DoGetNewAccessTokenByRefreshToken");
        if (isCanNewUseAccessToken) {
          await store.dispatch("DoUpdateAccessToken");
        }
      }
    }, 3660000);
  }
};

export const ClearTimerCheckAccessToken = () => {
  if (IsMasterTab()) {
    clearInterval(timerCheckAccessToken);
  }
};

export const CheckStatusSocket = () => {
  if (IsMasterTab()) {
    if (!appVue.$socket || appVue.$socket.disconnected) {
      appVue.$socket.connect();
    }
  } else if (appVue.$socket && appVue.$socket.connected) {
    appVue.$socket.disconnect();
  }
};

export const SocketConnect = () => {
  if (IsMasterTab()) {
    if (appVue.$socket && appVue.$socket.disconnected) {
      appVue.$socket.connect();
    }
  } else if (!IsMasterTabAvailable()) {
    SetMasterTab();
    if (appVue.$socket && appVue.$socket.disconnected) {
      appVue.$socket.connect();
    }
    store.commit("MutationSetNotificationReadyToUse", true);
  } else {
    store.commit("MutationSetNotificationReadyToUse", true);
  }
};

export const SocketAuthentication = () => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    let eui = btoa(userInfo.UserId());
    let accessToken = userInfo.GetAccessToken();
    appVue.$socket.emit("authentication", {
      eui: eui,
      accessToken: accessToken,
    });
  }
};

export const SocketDisconnect = () => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    appVue.$socket.disconnect();
  }
};

export const DoGetAllNotificationList = (merchantId) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch("DoGetAllNotificationList", merchantId);
  }
};

export const DoGetUnseenNotificationCount = (merchantId) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch("DoGetUnseenNotificationCount", merchantId);
  }
};

export const DoDeleteSeenNotification = (merchantId, notificationId, isSeen) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch("DoDeleteSeenNotification", { merchantId: merchantId, notificationId: notificationId });
  }
};

export const DoDeleteUnseenNotification = (merchantId, notificationId, isSeen) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch("DoDeleteUnseenNotification", { merchantId: merchantId, notificationId: notificationId });
  }
};

export const DoSetAllNotificationIsSeen = (merchantId) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch("DoSetAllNotificationIsSeen", merchantId);
  }
};

export const DoAddNotificationCount = async (merchantId, notificationCount) => {
  let notificationCountModelForInsert = {
    merchantId: merchantId,
    notificationCount: notificationCount,
  };
  let notificationCountModel = await GetNotificationCountFromIndexedDB(merchantId);
  if (notificationCountModel) {
    await UpdateNotificationCountToIndexedDB(notificationCountModelForInsert);
  } else {
    await AddNotificationCountToIndexedDB(notificationCountModelForInsert);
  }
};

export const DoGetNotificationCount = async (merchantId) => {
  let notificationCountModel = await GetNotificationCountFromIndexedDB(merchantId);
  return notificationCountModel ? notificationCountModel.notificationCount : 0;
};

export const DoAddUnreadNotificationList = async (merchantId, notificationList) => {
  let notificationModelForInsert = {
    merchantId: merchantId,
    notificationList: notificationList,
  };

  let notificationModel = await GetUnreadNotificationFromIndexedDB(merchantId);

  if (notificationModel) {
    await UpdateUnreadNotificationToIndexedDB(notificationModelForInsert);
  } else {
    await AddUnreadNotificationToIndexedDB(notificationModelForInsert);
  }
};

export const DoGetReadAllNotificationList = async (merchantId) => {
  let notificationModel = await GetReadNotificationFromIndexedDB(merchantId);
  return notificationModel ? notificationModel.notificationList : [];
};

export const DoAddReadNotificationList = async (merchantId, notificationList) => {
  let notificationModelForInsert = {
    merchantId: merchantId,
    notificationList: notificationList,
  };
  let notificationModel = await GetReadNotificationFromIndexedDB(merchantId);
  if (notificationModel) {
    await UpdateReadNotificationToIndexedDB(notificationModelForInsert);
  } else {
    await AddReadNotificationToIndexedDB(notificationModelForInsert);
  }
};

export const DoGetUnreadAllNotificationList = async (merchantId) => {
  let notificationModel = await GetUnreadNotificationFromIndexedDB(merchantId);
  return notificationModel ? notificationModel.notificationList : [];
};

export const DoDeleteNotificationById = async (merchantId, notificationId, isSeen) => {
  if (IsMasterTab()) {
    if (isSeen) {
      DoDeleteSeenNotification(merchantId, notificationId, isSeen);
      let notificationList = await DoGetReadAllNotificationList(merchantId);
      notificationList = RemoveNotificationFromNotificationList(notificationList, notificationId);
      await UpdateReadNotificationToIndexedDB({ merchantId: merchantId, notificationList: notificationList });
    } else {
      DoDeleteUnseenNotification(merchantId, notificationId, isSeen);
      let notificationList = await DoGetUnreadAllNotificationList(merchantId);
      notificationList = RemoveNotificationFromNotificationList(notificationList, notificationId);
      await UpdateUnreadNotificationToIndexedDB({ merchantId: merchantId, notificationList: notificationList });
      let notificationCount = await DoGetNotificationCount(merchantId);
      await UpdateNotificationCountToIndexedDB({ merchantId: merchantId, notificationCount: notificationCount - 1 });
      await store.commit("MutationSetNotificationCountFromIndexedDB");
      BroadcastIsUpdateNotificationCount(merchantId);
    }
    await store.commit("MutationSetNotificationListFromIndexedDB");
    BroadcastIsUpdateNotificationList(merchantId);
  } else {
    BroadcastMasterDeleteNotificationById(merchantId, notificationId, isSeen);
  }
};

export const DoDeleteNotificationByIdFromEmit = async (merchantId, notificationId) => {
  if (IsMasterTab()) {
    let readNotificationList = await DoGetReadAllNotificationList(merchantId);
    readNotificationList = RemoveNotificationFromNotificationList(readNotificationList, notificationId);
    await UpdateReadNotificationToIndexedDB({ merchantId: merchantId, notificationList: readNotificationList });

    let unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    unreadNotificationList = RemoveNotificationFromNotificationList(unreadNotificationList, notificationId);
    await UpdateUnreadNotificationToIndexedDB({ merchantId: merchantId, notificationList: unreadNotificationList });
    let notificationCount = await DoGetNotificationCount(merchantId);
    await UpdateNotificationCountToIndexedDB({ merchantId: merchantId, notificationCount: notificationCount - 1 });
    await store.commit("MutationSetNotificationCountFromIndexedDB");
    BroadcastIsUpdateNotificationCount(merchantId);

    await store.commit("MutationSetNotificationListFromIndexedDB");
    BroadcastIsUpdateNotificationList(merchantId);
  }
};

export const DoSetNotificationIsSeenAll = async (merchantId) => {
  if (IsMasterTab()) {
    DoSetAllNotificationIsSeen(merchantId);
    let unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    let readNotificationList = await DoGetReadAllNotificationList(merchantId);
    await UpdateUnreadNotificationToIndexedDB({ merchantId: merchantId, notificationList: [] });
    await UpdateNotificationCountToIndexedDB({ merchantId: merchantId, notificationCount: 0 });

    await DoAddReadNotificationList(merchantId, [...unreadNotificationList, ...readNotificationList]);

    await store.commit("MutationSetNotificationCountFromIndexedDB");
    BroadcastIsUpdateNotificationCount(merchantId);

    await store.commit("MutationSetNotificationListFromIndexedDB");
    BroadcastIsUpdateNotificationList(merchantId);
  } else {
    BroadcastMasterSetNotificationIsSeenAll(merchantId);
  }
};

export const RemoveNotificationFromNotificationList = (notificationList, notificationId) => {
  if (notificationList && notificationList.length > 0) {
    let findIndex = notificationList.findIndex((x) => x.id === notificationId);
    if (findIndex > -1) {
      notificationList.splice(findIndex, 1);
      return notificationList;
    }
    return notificationList;
  }
  return [];
};

export const SetIsSeenForNotification = (notificationList, isSeen) => {
  if (notificationList && notificationList.length > 0) {
    notificationList.forEach((notificationItem) => {
      notificationItem.isSeen = isSeen;
    });
    return notificationList;
  }
  return [];
};

export const SortDataNotification = (notificationList) => {
  if (notificationList && notificationList.length > 0) {
    return notificationList.sort((a, b) => {
      const notificationDateTimeA = new Date(a.notificationDateTime);
      const notificationDateTimeB = new Date(b.notificationDateTime);
      return notificationDateTimeB - notificationDateTimeA;
    });
  }
  return [];
};

export const CheckMerchantIsActiveOtherTab = async (merchantId) => {
  let tabId = GetTabIdFromSessionStorage();
  if (tabId) {
    let allTabs = await GetAllTabs();
    return allTabs.some((x) => x.id !== tabId && x.merchantId == merchantId);
  }
  return false;
};

export const CheckMerchantIsLoadNotification = async (merchantId) => {
  let unreadNotificationModel = await GetUnreadNotificationFromIndexedDB(merchantId);
  let readNotificationModel = await GetReadNotificationFromIndexedDB(merchantId);
  return unreadNotificationModel || readNotificationModel ? true : false;
};

export const CheckMerchantIsActive = async (merchantId) => {
  let isActive = false;
  if (merchantId > 0) {
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      let allTabs = await GetAllTabs();
      let isHaveSomeTabSameMerchant = allTabs.some((x) => x.merchantId == merchantId);
      if (isHaveSomeTabSameMerchant) {
        isActive = true;
      }
    } else {
      isActive = true;
    }
  }
  return isActive;
};

export const ForceSetMaster = async (merchantId) => {
  BroadcastDisconnectNotificationAllTab();
  ClearTabFromLocalStorage();
  ClearTabFromSessionStorage();
  await DeleteTabFromIndexedDB();
  await DeleteNotificationIndexedDB();
  await InsertTabIdToTabDB();
  await UpdateTabMerchantId(merchantId);
  DoGetUnseenNotificationCount(merchantId);
  BroadcastReCreateTab();
};

export const GetSuccessHeaderReport = (messageTypeId, messageDescription) => {
  let headerMessage = "";
  const _messageDescription = messageDescription ? messageDescription : "";
  switch (messageTypeId) {
    case enums.NotificationMessageType.Quotation:
      headerMessage = i18n.t("Success_QuotationReport");
      break;
    case enums.NotificationMessageType.PurcahseOrder:
      headerMessage = i18n.t("Success_POReport");
      break;
    case enums.NotificationMessageType.Invoice:
    case enums.NotificationMessageType.InvoiceAllProduct:
      headerMessage = i18n.t("Success_InvoiceReport");
      break;
    case enums.NotificationMessageType.Expense:
    case enums.NotificationMessageType.ExpenseAllProduct:
      headerMessage = i18n.t("Success_ExpenseReport");
      break;
    case enums.NotificationMessageType.PurchaseAsset:
    case enums.NotificationMessageType.PurchaseAssetAllProduct:
      headerMessage = i18n.t("Success_PurchaseAssetReport");
      break;
    case enums.NotificationMessageType.Receipt:
      headerMessage = i18n.t("Success_ReceiptReport");
      break;
    case enums.NotificationMessageType.TaxInvoice:
    case enums.NotificationMessageType.TaxInvoiceInRevenueDepartmentFormat:
      headerMessage = i18n.t("Success_TaxInvoiceReport");
      break;
    case enums.NotificationMessageType.PurcahseTaxInvoice:
    case enums.NotificationMessageType.PurchaseTaxInvoiceInRevenueDepartFormat:
      headerMessage = i18n.t("Success_PurchaseTaxInvoiceReport");
      break;
    case enums.NotificationMessageType.AllReportTaxInvoiceFromOldPeak:
      headerMessage = i18n.t("Success_TaxInvoiceReportFromOldPeak");
      break;
    case enums.NotificationMessageType.AllReportPurchaseTaxInvoiceFromOldPeak:
      headerMessage = i18n.t("Success_PurchaseTaxInvoiceReportFromOldPeak");
      break;
    case enums.NotificationMessageType.AllReportTaxInvoiceFromPeakTax:
      headerMessage = i18n.t("Success_TaxInvoiceReportFromPeakTax");
      break;
    case enums.NotificationMessageType.AllReportPurchaseTaxInvoiceFromPeakTax:
      headerMessage = i18n.t("Success_PurchaseTaxInvoiceReportFromPeakTax");
      break;
    case enums.NotificationMessageType.BillingNoteInvoice:
    case enums.NotificationMessageType.BillingNoteInvoiceAllInvoice:
      headerMessage = i18n.t("Success_BillingNoteReport");
      break;
    case enums.NotificationMessageType.BillingNoteExpense:
    case enums.NotificationMessageType.BillingNoteExpenseAllExpense:
      headerMessage = i18n.t("Success_CombinePaymentNoteReport");
      break;
    case enums.NotificationMessageType.StockActivityStockCardMovement:
      headerMessage = i18n.t("Success_StockMovementReport");
      break;
    case enums.NotificationMessageType.Journal:
      headerMessage = i18n.t("Success_DailyJournalReport");
      break;
    case enums.NotificationMessageType.TrialBalance:
    case enums.NotificationMessageType.TrialBalanceWithSubAccount:
      headerMessage = i18n.t("Success_TrialBalanceReport");
      break;
    case enums.NotificationMessageType.TrialBalanceSeperateMonth:
      headerMessage = i18n.t("Success_TrialBalanceSeperateMonthReport");
      break;
    case enums.NotificationMessageType.Finance:
      headerMessage = i18n.t("Success_FinanceReport");
      break;
    case enums.NotificationMessageType.PP30InputVat:
      headerMessage = i18n.t("Success_PP30InputVat");
      break;
    case enums.NotificationMessageType.PP30OutputVat:
      headerMessage = i18n.t("Success_PP30OutputVat");
      break;
    case enums.NotificationMessageType.CreditNote:
      headerMessage = i18n.t("Success_CreditnoteReport");
      break;
    case enums.NotificationMessageType.CreditNoteExpense:
      headerMessage = i18n.t("Success_CreditnoteExpenseReport");
      break;
    case enums.NotificationMessageType.AssetTemplate:
      headerMessage = i18n.t("Success_AssetTemplateReport");
      break;
    case enums.NotificationMessageType.AssetTemplateGroup:
      headerMessage = i18n.t("Success_AssetTemplateGroupReport");
      break;
    case enums.NotificationMessageType.WithHeldTax:
      headerMessage = i18n.t("Success_WithHeldTaxReport");
      break;
    case enums.NotificationMessageType.WithHoldingTax:
      headerMessage = i18n.t("Success_WithHoldingTaxReport");
      break;
    case enums.NotificationMessageType.GeneralLedgerTransaction:
      headerMessage = i18n.t("Success_GeneralLedger_Transaction");
      break;
    case enums.NotificationMessageType.AllGeneralLedger:
      headerMessage = i18n.t("Success_AllGeneralLedger");
      break;
    case enums.NotificationMessageType.AllGeneralLedgerWithSubAccount:
      headerMessage = i18n.t("Success_GeneralLedger_Transaction");
      break;
    case enums.NotificationMessageType.AgingReportAR:
      headerMessage = i18n.t("Success_Aging_Report_AR");
      break;
    case enums.NotificationMessageType.AgingReportAP:
      headerMessage = i18n.t("Success_Aging_Report_AP");
      break;
    case enums.NotificationMessageType.Product:
      headerMessage = i18n.t("Success_Product");
      break;
    case enums.NotificationMessageType.ProfitLoss:
      headerMessage = i18n.t("Success_ProfitLoss");
      break;
    case enums.NotificationMessageType.ChartOfAccount:
      headerMessage = i18n.t("Success_ChartOfAccount");
      break;
    case enums.NotificationMessageType.BalanceSheet:
      headerMessage = i18n.t("Success_BalanceSheet");
      break;
    case enums.NotificationMessageType.Unit:
      headerMessage = i18n.t("Success_Unit");
      break;
    case enums.NotificationMessageType.ReportDocument:
      headerMessage = i18n.t("Success_ReportDocument");
      break;
    case enums.NotificationMessageType.Asset:
      headerMessage = i18n.t("Success_AssetReport");
      break;
    case enums.NotificationMessageType.StatementEFiling:
      headerMessage = i18n.t("Success_StatementEFiling");
      break;
    case enums.NotificationMessageType.Contact:
      headerMessage = i18n.t("Success_ReportContact");
      break;
    case enums.NotificationMessageType.PurchaseTaxInvoiceNotUse:
      headerMessage = i18n.t("AllReportPurchaseTaxInvoiceNotUse");
      break;
    case enums.NotificationMessageType.SalesTaxInvoiceNotUse:
      headerMessage = i18n.t("AllReportSalesTaxInvoiceNotUse");
      break;
    case enums.NotificationMessageType.AllReportPurchaseTaxInvoiceNotUseFromOldPeak:
      headerMessage = i18n.t("AllReportPurchaseTaxInvoiceNotUseFromOldPeak");
      break;
    case enums.NotificationMessageType.AllReportSalesTaxInvoiceNotUseFromOldPeak:
      headerMessage = i18n.t("AllReportSalesTaxInvoiceNotUseFromOldPeak");
      break;
    case enums.NotificationMessageType.AllReportPurchaseTaxInvoiceNotUseFromPeakTax:
      headerMessage = i18n.t("AllReportPurchaseTaxInvoiceNotUseFromPeakTax");
      break;
    case enums.NotificationMessageType.AllReportSalesTaxInvoiceNotUseFromPeakTax:
      headerMessage = i18n.t("AllReportSalesTaxInvoiceNotUseFromPeakTax");
      break;
    case enums.NotificationMessageType.PP30TaxFilingTextFile:
      headerMessage = i18n.t("Success_PP30TaxFilingTextFile");
      break;
    case enums.NotificationMessageType.WithHoldingTaxPND2:
      headerMessage = i18n.t("Success_WithHoldingTaxPND2");
      break;
    case enums.NotificationMessageType.WithHoldingTaxPND3:
      headerMessage = i18n.t("Success_WithHoldingTaxPND3");
      break;
    case enums.NotificationMessageType.WithHoldingTaxPND53:
      headerMessage = i18n.t("Success_WithHoldingTaxPND53");
      break;
    case enums.NotificationMessageType.CashflowStatementReport:
      headerMessage = i18n.t("Success_CashflowStatementReport");
      break;
    case enums.NotificationMessageType.AllReportSalesByCustomerReport:
      headerMessage = i18n.t("Success_AllReportSalesByCustomerReport");
      break;
    case enums.NotificationMessageType.AllReportSalesByAccountReport:
      headerMessage = i18n.t("Success_AllReportSalesByAccountReport");
      break;
    case enums.NotificationMessageType.StatementEFilingExcel:
      headerMessage = i18n.t("Success_StatementEFilingExcel");
      break;
    case enums.NotificationMessageType.AllReportProductSalesByContact:
      headerMessage = i18n.t("Success_AllReportProductSalesByContact");
      break;
    case enums.NotificationMessageType.AllReport_ProductServiceSalesSummaryReportOnDailyAccount:
      headerMessage = i18n.t("Success_AllReport_ProductServiceSalesSummaryReportOnDailyAccount");
      break;
    case enums.NotificationMessageType.AllReport_RemainingFinanceBalanceReport:
      headerMessage = i18n.t("Success_AllReport_RemainingFinanceBalanceReport");
      break;
    case enums.NotificationMessageType.Pnd53TaxFilingTextFile:
      headerMessage = i18n.t("Success_Pnd53TaxFilingTextFile");
      break;
    case enums.NotificationMessageType.Pnd3TaxFilingTextFile:
      headerMessage = i18n.t("Success_Pnd3TaxFilingTextFile");
      break;
    case enums.NotificationMessageType.DailyJournal:
      headerMessage = i18n.t("Success_DailyJournal");
      break;
    case enums.NotificationMessageType.DocumentQuotation:
      headerMessage = i18n.t("Success_DocumentQuotation");
      break;
    case enums.NotificationMessageType.DocumentInvoice:
      headerMessage = i18n.t("Success_DocumentInvoice");
      break;
    case enums.NotificationMessageType.DocumentReceipt:
      headerMessage = i18n.t("Success_DocumentReceipt");
      break;
    case enums.NotificationMessageType.DocumentTaxInvoice:
      headerMessage = i18n.t("Success_DocumentTaxInvoice");
      break;
    case enums.NotificationMessageType.DocumentPurchaseOrder:
      headerMessage = i18n.t("Success_DocumentPurchaseOrder");
      break;
    case enums.NotificationMessageType.DocumentExpense:
      headerMessage = i18n.t("Success_DocumentExpense");
      break;
    case enums.NotificationMessageType.DocumentBillingNote:
      headerMessage = i18n.t("Success_DocumentBillingNote");
      break;
    case enums.NotificationMessageType.DocumentBillingNoteExpense:
      headerMessage = i18n.t("Success_DocumentBillingNoteExpense");
      break;
    case enums.NotificationMessageType.DocumentCreditNote:
      headerMessage = i18n.t("Success_DocumentCreditNote");
      break;
    case enums.NotificationMessageType.DocumentCreditNoteExpense:
      headerMessage = i18n.t("Success_DocumentCreditNoteExpense");
      break;
    case enums.NotificationMessageType.DocumentPurchaseTaxInvoice:
      headerMessage = i18n.t("Success_DocumentPurchaseTaxInvoice");
      break;
    case enums.NotificationMessageType.DocumentWithholdingTax:
      headerMessage = i18n.t("Success_DocumentWithholdingTax");
      break;
    case enums.NotificationMessageType.ImportTransactionPurchaseInventory:
      headerMessage = i18n.t("Success_ImportTransactionPurchaseInventory");
      break;
    case enums.NotificationMessageType.ImportTransactionExpense:
      headerMessage = i18n.t("Success_ImportTransactionExpense");
      break;
    case enums.NotificationMessageType.ImportTransactionInvoice:
      headerMessage = i18n.t("Success_ImportTransactionInvoice");
      break;
    case enums.NotificationMessageType.ImportTransactionReceipt:
      headerMessage = i18n.t("Success_ImportTransactionReceipt");
      break;
    case enums.NotificationMessageType.ImportTransactionQuotation:
      headerMessage = i18n.t("Success_ImportTransactionQuotation");
      break;
    case enums.NotificationMessageType.ImportTransactionPurchaseOrder:
      headerMessage = i18n.t("Success_ImportTransactionPurchaseOrder");
      break;
    case enums.NotificationMessageType.Statement:
      headerMessage = i18n.t("Success_Statement");
      break;
    case enums.NotificationMessageType.AllReportWithHoldingTaxPND2:
      headerMessage = i18n.t("Success_AllReportWithHoldingTaxPND2");
      break;
    case enums.NotificationMessageType.AllReportWithHoldingTaxPND3:
      headerMessage = i18n.t("Success_AllReportWithHoldingTaxPND3");
      break;
    case enums.NotificationMessageType.AllReportWithHoldingTaxPND53:
      headerMessage = i18n.t("Success_AllReportWithHoldingTaxPND53");
      break;
    case enums.NotificationMessageType.ChequeReport:
      headerMessage = i18n.t("Success_ChequeReport");
      break;
    case enums.NotificationMessageType.WorkingPaper:
      headerMessage = i18n.t("Success_WorkingPaperReport");
      break;
    case enums.NotificationMessageType.RecalCostOfGoodSoldByMerchantCalculated:
      headerMessage = i18n.t("Success_RecalCostOfGoodSoldByMerchantCalculated");
      break;
    case enums.NotificationMessageType.RecalCostOfGoodSoldByProductCalculated:
      headerMessage = i18n.t("Success_RecalCostOfGoodSoldByProductCalculated");
      break;
    case enums.NotificationMessageType.RecalCostOfGoodSoldFailed:
      headerMessage = i18n.t("Success_RecalCostOfGoodSoldFailed");
      break;
    case enums.NotificationMessageType.DebitNote:
      headerMessage = i18n.t("Success_DebitNoteReport");
      break;
    case enums.NotificationMessageType.DocumentDebitNote:
      headerMessage = i18n.t("Success_DocumentDebitNote");
      break;
    case enums.NotificationMessageType.DocumentDebitNoteExpense:
      headerMessage = i18n.t("Success_DocumentDebitNoteExpense");
      break;
    case enums.NotificationMessageType.VoidImportTransactionFailed:
      headerMessage = i18n.t("Success_VoidImportTransactionFailed");
      break;
    case enums.NotificationMessageType.VoidImportTransactionSuccess:
      headerMessage = i18n.t("Success_VoidImportTransactionSuccess");
      break;
    case enums.NotificationMessageType.ImportTransactionReceiptFromInvoice:
      headerMessage = i18n.t("Success_ImportTransactionReceiptFromInvoice");
      break;
    case enums.NotificationMessageType.ImportTransactionJournal:
      headerMessage = i18n.t("Success_ImportTransactionJournal");
      break;
    case enums.NotificationMessageType.DepreciateAssetMonthly:
      headerMessage = i18n.t("Success_DepreciateAssetMonthly") + " " + _messageDescription;
      break;
    case enums.NotificationMessageType.TaxPnd:
      headerMessage = i18n.t("Success_WithHoldingTaxReport");
      break;
    case enums.NotificationMessageType.TaxPP30SaleTax:
      headerMessage = i18n.t("Success_TaxInvoiceReport");
      break;
    case enums.NotificationMessageType.TaxPP30PurchaseTax:
      headerMessage = i18n.t("Success_PurchaseTaxInvoiceReport");
      break;
    case enums.NotificationMessageType.TaxFetchPP30Transaction:
      headerMessage = i18n.t("Success_TaxFetchPP30Transaction");
      break;
    case enums.NotificationMessageType.TaxFetchWhtCertificate:
      headerMessage = i18n.t("Success_TaxFetchWhtCertificate");
      break;
    case enums.NotificationMessageType.FinanceBankStatement:
      headerMessage = i18n.t("Success_FinanceBankStatementReport");
      break;
    case enums.NotificationMessageType.ExecutiveSummary:
      headerMessage = i18n.t("Success_ExecutiveSummaryReport");
      break;
    case enums.NotificationMessageType.StatementOfCashflow:
      headerMessage = i18n.t("Success_StatementOfCashflow");
      break;
    case enums.NotificationMessageType.RecieveBenefit:
    case enums.NotificationMessageType.CamPaignBeforeExpire:
    case enums.NotificationMessageType.BeforeExpireByDate:
    case enums.NotificationMessageType.QuotaExpire:
      headerMessage = _messageDescription;
      break;
  }
  return headerMessage;
};
